import { handleActions } from 'redux-actions';
import { Actions as DeviceActions, getDeviceEventsRequest, getDeviceEventsSuccess, getDeviceEventsFailure } from 'actions/deviceEventsActions';
import { Actions as SessionActions } from 'actions/sessionActions';
import { DeviceEvent } from 'shared/models';
import { merge, Dictionary } from 'lodash';

type DeviceEventsMap = Dictionary<DeviceEvent>;

export type State = Readonly<{
    data: Dictionary<DeviceEventsMap>;
    loading: Dictionary<boolean>;
    hasMore: Dictionary<boolean>;
    error: string | null;
}>;

export const initialState = Object.freeze<State>({
    data: {},
    loading: {},
    hasMore: {},
    error: null,
});

export const deviceEventsReducer = handleActions({
    //
    //  Device Actions
    //
    [DeviceActions.GET_DEVICE_EVENTS_REQUEST]: (state: State, action: ReturnType<typeof getDeviceEventsRequest>) => {
        const deviceId = action.payload;
        return merge({}, state, {
            loading: {
                [deviceId]: true,
            },
        });
    },
    [DeviceActions.GET_DEVICE_EVENTS_SUCCESS]: (state: State, action: ReturnType<typeof getDeviceEventsSuccess>) => {
        const { deviceId, more } = action.meta;
        return merge({}, state, {
            data: {
                [deviceId]: action.payload,
            },
            loading: {
                [deviceId]: false,
            },
            hasMore: {
                [deviceId]: more,
            },
            error: null,
        });
    },
    [DeviceActions.GET_DEVICE_EVENTS_FAILURE]: (state: State, action: ReturnType<typeof getDeviceEventsFailure>) => {
        const { deviceId } = action.meta;
        return merge({}, state, {
            loading: {
                [deviceId]: false,
            },
            error: action.payload.message,
        });
    },

    //
    //  Session Actions
    //
    [SessionActions.LOGOUT_SUCCESS]: () => {
        return initialState;
    },
} as any, initialState);
